import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-e-sign-parent',
    templateUrl: './e-sign-parent.component.html',
    styleUrls: ['./e-sign-parent.component.scss'],
    standalone: false
})
export class ESignParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
